import { useState, type FormEvent } from 'react'
import { Panel, Button } from '../ds/index'
import { PasswordField } from '../components/PasswordField'
import { post } from '../lib/api'
import { useSession } from '../lib/session'
import { MIN_PASSWORD } from '../lib/password'

/**
 * First sign-in on a starting password someone else chose. The server refuses
 * everything else until this is done, so this is the whole app until then.
 */
export default function ChooseOwnPassword() {
  const { me, refresh } = useSession()
  const [pw, setPw] = useState({ current: '', next: '', again: '' })
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setErr(null)
    if (pw.next !== pw.again) { setErr('The two new passwords do not match'); return }
    setBusy(true)
    try {
      await post('/api/account/password', { current_password: pw.current, new_password: pw.next })
      await refresh()
    } catch (e2) { setErr((e2 as Error).message); setBusy(false) }
  }
  const signOut = async () => {
    try { await post('/api/auth/logout', {}) } finally { window.location.assign('/') }
  }

  const first = me?.user.name.split(' ')[0] || ''
  return (
    <div className="login">
      <Panel className="login-card">
        <div className="login-mark">{first ? `Welcome, ${first}` : 'Welcome'}</div>
        <p className="login-sub">You signed in with a starting password. Choose your own to continue.</p>
        <form onSubmit={submit} className="stack">
          <input type="email" autoComplete="username" value={me?.user.email || ''} readOnly hidden />
          <PasswordField label="Starting password" autoFocus autoComplete="current-password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} />
          <PasswordField label="New password" autoComplete="new-password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} />
          <PasswordField label="New password again" autoComplete="new-password" value={pw.again} onChange={(e) => setPw({ ...pw, again: e.target.value })} />
          <p className="form-help" style={{ margin: 0 }}>At least {MIN_PASSWORD} characters, and not the starting one.</p>
          {err && <p className="form-error" role="alert">{err}</p>}
          <Button type="submit" disabled={busy || !pw.current || pw.next.length < MIN_PASSWORD || !pw.again}>{busy ? 'Saving' : 'Save and continue'}</Button>
          <Button type="button" variant="ghost" onClick={signOut}>Sign out</Button>
        </form>
        <div className="powered">Powered by SPEC Systems</div>
      </Panel>
    </div>
  )
}
